import _objectSpread from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
export default {
  mixins: [popUp],
  props: ['teamId'],
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        id: '',
        height: "",
        weight: "",
        preferred_foot: "",
        jersey_number: '',
        position: ""
      },
      imgList: [],
      ageGroupList: [],
      venuesLists: [],
      rules: {
        height: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        weight: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        preferred_foot: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        can_register: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        jersey_number: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        position: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }]
      }
    };
  },
  computed: {},
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var datas;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  console.log("data==", data);

                  _this.copyPrimitive();

                  datas = JSON.parse(JSON.stringify(data));
                  _this.formData.student_id = datas.student_id;
                  _this.formData.height = datas.height;
                  _this.formData.weight = datas.weight;
                  _this.formData.preferred_foot = datas.preferred_foot;
                  _this.formData.jersey_number = datas.jersey_number;
                  _this.formData.position = datas.position;
                  _this.imgList = [datas.logo];

                  _this.copyData();
                }

                _this.dialogFormVisible = true;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    rewriteClearData: function rewriteClearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.imgList = isClear ? [] : this.formDataMake.logo ? [this.formDataMake.logo] : [];
      this.clearData(isClear);
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$refs.ruleForm.validate(function (valid) {
                  if (valid) {
                    var data = JSON.parse(JSON.stringify(_this2.formData));

                    _this2.$api.changeStudentInfo(_objectSpread(_objectSpread({}, data), {}, {
                      team_id: _this2.teamId
                    })).then(function (res) {
                      if (res.code == 200) {
                        _this2.$message.success('操作成功');

                        _this2.$emit('change');

                        _this2.dialogFormVisible = false;
                      } else {
                        _this2.$message.error(res.msg);
                      }
                    });
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};